/**
 * 复制文本到粘贴板
 * @param {string} copyContext
 * @param {function} callbackFun 复制之后的回调函数
 * @returns boolean 复制成功/失败
 *
 * # 兼容58App和非58App内的复制
 * 调用结束之后返回boolean 成功或者失败
 */
import { is58App } from './appTools';
var CodeStatus;
(function (CodeStatus) {
    CodeStatus[CodeStatus["SUCCESS"] = 0] = "SUCCESS";
    CodeStatus[CodeStatus["FAILED"] = 1] = "FAILED";
    CodeStatus[CodeStatus["NOTHING"] = 2] = "NOTHING";
})(CodeStatus || (CodeStatus = {}));
var MsgStatus;
(function (MsgStatus) {
    MsgStatus["SUCCESS"] = "\u590D\u5236\u6210\u529F";
    MsgStatus["FAILED"] = "\u590D\u5236\u5931\u8D25\uFF0C\u8BF7\u9009\u4E2D\u6587\u672C\u8FDB\u884C\u590D\u5236";
    MsgStatus["NOTHING"] = "\u590D\u5236\u5931\u8D25\uFF0C\u6CA1\u6709\u627E\u5230\u4EFB\u4F55\u7684\u5185\u5BB9";
})(MsgStatus || (MsgStatus = {}));
var resultMsg = {
    Success: {
        code: CodeStatus.SUCCESS,
        msg: MsgStatus.SUCCESS,
    },
    Failed: {
        code: CodeStatus.FAILED,
        msg: MsgStatus.FAILED,
    },
    Nothing: {
        code: CodeStatus.NOTHING,
        msg: MsgStatus.NOTHING,
    },
};
export var copyText = function (copyContext, 
// eslint-disable-next-line no-empty-function
callbackFun) {
    if (copyContext === void 0) { copyContext = ''; }
    if (callbackFun === void 0) { callbackFun = function (tips) { }; }
    if (!copyContext) {
        // 增加个轻提示文案
        callbackFun(resultMsg.Nothing);
        return false;
    }
    if (is58App() && typeof WBAPP != 'undefined') {
        appCopyText(copyContext, callbackFun);
    }
    else {
        notAppCopyText(copyContext, callbackFun);
    }
};
// 58App内的复制
export var appCopyText = function (copyContext, 
// eslint-disable-next-line no-empty-function
callbackFun) {
    if (copyContext === void 0) { copyContext = ''; }
    if (callbackFun === void 0) { callbackFun = function (tips) { }; }
    WBAPP.invoke('set_clipboard', {
        data: copyContext,
    });
    setTimeout(function () {
        WBAPP.invoke('get_clipboard', function (data) {
            callbackFun(data ? resultMsg.Success : resultMsg.Failed);
        });
    }, 100);
};
// 非58APP内的复制
export var notAppCopyText = function (copyContext, 
// eslint-disable-next-line no-empty-function
callbackFun) {
    if (copyContext === void 0) { copyContext = ''; }
    if (callbackFun === void 0) { callbackFun = function (tips) { }; }
    if (!document.execCommand) {
        callbackFun(resultMsg.Failed);
        return false;
    }
    var input = document.createElement('input');
    input.readOnly = true;
    input.value = copyContext;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    var result = document.execCommand('Copy', true);
    document.body.removeChild(input);
    callbackFun(result ? resultMsg.Success : resultMsg.Failed);
};
